import { Transition } from "@headlessui/react";
import React from "react";
import Avatar from "../../assets/images/svg/user.svg";

const StarRating = () => {
  return (
    <div className="flex">
      <div className="mb-6 leading-6 text-xs text-white font-bold bg-utiva-green flex items-center pl-3 pr-4 py-1 rounded-full">
        <svg
          width="13"
          height="12"
          viewBox="0 0 13 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.5 0L7.95934 4.49139H12.6819L8.86126 7.26722L10.3206 11.7586L6.5 8.98278L2.6794 11.7586L4.13874 7.26722L0.318133 4.49139H5.04066L6.5 0Z"
            fill="white"
          />
        </svg>
        <span className="pl-1">5.0</span>
      </div>
    </div>
  );
};

const StoryModal = ({
  show,
  handleModalClose,
  selectedTestimony,
  title,
  ...props
}) => {
  return (
    <div className="fixed z-10 inset-0 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <Transition
          show={show}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 transition-opacity" aria-hidden="true">
            <div className="absolute inset-0 bg-black opacity-70"></div>
          </div>
        </Transition>

        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>

        <div
          className="inline-block align-center bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-headline"
        >
          <div className="pt-8" />
          <div className="bg-white px-5 py-1 sm:px-12 sm:py-6">
            <div className="">
              <StarRating />

              <div className="">
                <p className="text-sm lg:text-sm-15">
                  {selectedTestimony?.experience}
                </p>

                <div className="flex flex-row items-start mt-10">
                  <div className="w-11 h-11 object-cover bg-gray-2 rounded-full">
                    <img
                      src={
                        selectedTestimony?.imageUrl?.includes("cloudinary")
                          ? Avatar
                          : selectedTestimony?.imageUrl
                      }
                      alt=""
                      className="w-11 h-11 rounded-full object-cover"
                    />
                  </div>
                  <div className="pl-4">
                    <p className="text-primary font-bold text-sm lg:text-base">
                      {selectedTestimony?.name}
                    </p>
                    <p className="text-xs pt-">
                      {selectedTestimony?.companyRole}
                    </p>
                    <p className="text-xs pt-2">
                      {selectedTestimony?.createdAt &&
                        new Date(
                          selectedTestimony?.createdAt
                        ).toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })}
                    </p>
                  </div>
                </div>

                <div className="mb-3 mt-8 w-full relative text-center">
                  <button
                    type="button"
                    onClick={handleModalClose}
                    className="py-3 px-4 text-primary my-3 text-sm-15 focus:outline-none"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StoryModal;
